// src/pages/contract/OtrosiGH.jsx
import React, { useEffect, useState, useCallback, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchSelect from "../../../components/private/searchselect";
// ⭐ PAGINACIÓN
import Pagination from "../../../components/private/pagination";

const Otrosi = () => {
  const { authFetch, token } = useContext(AuthContext);
  const navigate = useNavigate();

  const [otrosi, setOtrosi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contracts, setContracts] = useState([]);
  const [loadingContracts, setLoadingContracts] = useState(false);

// modal crear otrosí
const [showCreateModal, setShowCreateModal] = useState(false);
const [creating, setCreating] = useState(false);
const [createError, setCreateError] = useState("");

const [formData, setFormData] = useState({
Id_contratogh: "",
salary: "",
position_company: "",
date_end: "",
functions: "",
bonus: "",
transport_assistance: "",
food_assistance: "",
});


  // filtros
  const [filter, setFilter] = useState({
    searchQuery: "",
    searchBy: "Id_contratogh",
  });

  // paginación
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =======================
  //   Cargar otrosí
  // =======================
  const loadOtrosi = useCallback(async () => {
    setLoading(true);
    try {
      const res = await authFetch(ENDPOINTS.getOtrosi);

      if (res.success && Array.isArray(res.otrosi)) {
        setOtrosi(res.otrosi);
      } else {
        setOtrosi([]);
      }
    } catch (err) {
      console.error("❌ Error cargando otrosí:", err);
      setOtrosi([]);
    } finally {
      setLoading(false);
    }
  }, [authFetch]);

  useEffect(() => {
    if (!token) return;
    loadOtrosi();
  }, [token, loadOtrosi]);

  // =======================
  //   Filtros
  // =======================
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((f) => ({ ...f, [name]: value }));
    setCurrentPage(1);
  };

  const handleSearchInput = (e) => {
    setFilter((f) => ({ ...f, searchQuery: e.target.value }));
    setCurrentPage(1);
  };

  // =======================
  //   Filtrar resultados
  // =======================
    const filterResults = () => {
    const q = filter.searchQuery.trim();

    if (!q) return otrosi;

    return otrosi.filter((o) => {
        switch (filter.searchBy) {
        case "Id":
            return String(o.Id).includes(q);

        case "Id_contratogh":
            return String(o.Id_contratogh).includes(q);

        default:
            return true;
        }
    });
    };


  const filtered = filterResults();

  // paginación
  const totalPages = Math.max(1, Math.ceil(filtered.length / recordsPerPage));
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentOtrosi = filtered.slice(indexOfFirst, indexOfLast);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

// CREAR OTRO SI
const handleFormChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};

const handleCreateOtrosi = async () => {
  setCreateError("");

  if (!formData.Id_contratogh) {
    setCreateError("El contrato es obligatorio");
    return;
  }

  // 🔥 SOLO enviar campos con valor real
  const payload = {
    Id_contratogh: formData.Id_contratogh,
  };

  Object.entries(formData).forEach(([key, value]) => {
    if (key === "Id_contratogh") return;

    if (
      value !== "" &&
      value !== null &&
      value !== undefined
    ) {
      payload[key] = value;
    }
  });

  if (Object.keys(payload).length === 1) {
    setCreateError("Debe modificar al menos un campo");
    return;
  }

  setCreating(true);

  try {
    const res = await authFetch(ENDPOINTS.createOtrosi, {
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (res.success) {
      setShowCreateModal(false);
      setFormData({
        Id_contratogh: "",
        salary: "",
        position_company: "",
        date_end: "",
        functions: "",
        bonus: "",
        transport_assistance: "",
        food_assistance: "",
      });
      loadOtrosi();
    } else {
      setCreateError(res.message || "Error creando otrosí");
    }
  } catch (err) {
    console.error(err);
    setCreateError("Error de conexión");
  } finally {
    setCreating(false);
  }
};

// CARGAR CONTRATOS
const loadContractsForSelect = async () => {
  setLoadingContracts(true);
  try {
    const res = await authFetch(ENDPOINTS.getContract);

    if (res.success && Array.isArray(res.contracts)) {
      // opcional: solo contratos vigentes
      const vigentes = res.contracts;
      setContracts(vigentes);
    } else {
      setContracts([]);
    }
  } catch (error) {
    console.error("Error cargando contratos:", error);
    setContracts([]);
  } finally {
    setLoadingContracts(false);
  }
};

const showNoAplicaMoney = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    Number(value) === 0
  ) {
    return <span className="text-muted">No aplica</span>;
  }

  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(Number(value));
};


const handleViewPdf = (otrosiId) => {
  if (!otrosiId) return;

  const url = `${ENDPOINTS.otrosiPdf}?id=${otrosiId}`;

  // abrir PDF en nueva pestaña
  window.open(url, "_blank");
};

const contractOptions = contracts.map((c) => ({
  value: c.id_contrato,
  label: `COD${c.id_contrato} - ${c.first_name} ${c.last_name}`,
}));

const formatMoney = (value) => {
  if (value === null || value === undefined) return "-";

  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(Number(value));
};



  if (loading) return <p>Cargando otrosí...</p>;

  return (
    <div className="container mt-4 p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Otrosí - Gestión Humana</h2>
        <button className="btn btn-outline-pink" onClick={() => navigate(-1)}>
          <i className="bi bi-arrow-left me-1"></i>Volver
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="m-1">Buscar</label>
          <input
            type="text"
            className="form-control"
            placeholder="Buscar por id o contrato..."
            value={filter.searchQuery}
            onChange={handleSearchInput}
          />
        </div>

        <div className="col-md-3">
          <label className="m-1">Buscar por:</label>
          <select
            className="form-select"
            name="searchBy"
            value={filter.searchBy}
            onChange={handleFilterChange}
          >
            <option value="Id">ID
            </option>
            <option value="Id_contratogh">Contrato</option>
          </select>
        </div>
        <div className="col-md-3 d-flex align-items-end">
            <button
                className="btn btn-outline-pink w-100"
                onClick={() => {
                    setShowCreateModal(true);
                    loadContractsForSelect();
                }}
                >
                <i className="bi bi-plus-lg me-1"></i> Crear Otro sí
            </button>

        </div>

      </div>

      {/* TABLA */}
      {currentOtrosi.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>ID</th>
                <th>Contrato</th>
                <th>Salario</th>
                <th>Cargo</th>
                <th>Fecha fin</th>
                <th>Funciones</th>
                <th>Bono</th>
                <th>Aux.transporte</th>
                <th>Aux.alimentacion</th>
                <th>Fecha otrosí</th>
                <th>Doc</th>
              </tr>
            </thead>

         <tbody>
            {currentOtrosi.map((o) => (
                <tr key={o.Id}>
                <td>{o.Id}</td>
                <td>{o.Id_contratogh}</td>
                <td>{formatMoney(o.salary)}</td>
                <td>{o.position_company || "-"}</td>
                <td>{o.date_end ? new Date(o.date_end).toLocaleDateString("es-CO"): "-"}</td>
                <td>{o.functions || "-"}</td>
                <td>{showNoAplicaMoney(o.bonus)}</td>
                <td>{showNoAplicaMoney(o.transport_assistance)}</td>
                <td>{showNoAplicaMoney(o.food_assistance)}</td>

                <td>{new Date(o.created_at).toLocaleDateString("es-CO")}</td>

                <td>  
                   <button
                        className="btn btn-outline-purple btn-sm me-2"
                        onClick={() => handleViewPdf(o.Id)}
                        >
                        <i className="bi bi-eye-fill me-1"></i> Ver PDF
                    </button>

                </td>
                </tr>
            ))}
            </tbody>
          </table>

          {/* PAGINACIÓN */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay registros de otrosí.</p>
      )}


      {/* MODAL CREAR OTRO SI */}
      {showCreateModal && (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title">Crear Otro sí</h5>
                <button
                    className="btn-close"
                    onClick={() => setShowCreateModal(false)}
                ></button>
                </div>

                <div className="modal-body">
                {createError && (
                    <div className="alert alert-danger">{createError}</div>
                )}

                <div className="mb-3">
                    <label className="form-label">Contrato *</label>

                    <SearchSelect
                        options={contractOptions}
                        value={formData.Id_contratogh}
                        onChange={(val) =>
                          setFormData(prev => ({ ...prev, Id_contratogh: val }))
                        }
                        placeholder="Buscar contrato..."
                        isLoading={loadingContracts}
                      />


                    {loadingContracts && (
                        <div className="small text-muted mt-1">Cargando contratos...</div>
                    )}
                </div>

                <div className="row">
                    <div className="col-md-6 mb-3">
                    <label>Salario</label>
                    <input
                        className="form-control"
                        name="salary"
                        value={formData.salary}
                        onChange={handleFormChange}
                    />
                    </div>

                    <div className="col-md-6 mb-3">
                    <label>Cargo</label>
                    <input
                        className="form-control"
                        name="position_company"
                        value={formData.position_company}
                        onChange={handleFormChange}
                    />
                    </div>
                </div>

                <div className="mb-3">
                    <label>Fecha fin</label>
                    <input
                    type="date"
                    className="form-control"
                    name="date_end"
                    value={formData.date_end}
                    onChange={handleFormChange}
                    />
                </div>

                <div className="mb-3">
                    <label>Funciones</label>
                    <textarea
                    className="form-control"
                    name="functions"
                    rows="3"
                    value={formData.functions}
                    onChange={handleFormChange}
                    />
                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                    <label>Bono</label>
                    <input
                        className="form-control"
                        name="bonus"
                        value={formData.bonus}
                        onChange={handleFormChange}
                    />
                    </div>

                    <div className="col-md-4 mb-3">
                    <label>Aux. transporte</label>
                    <input
                        className="form-control"
                        name="transport_assistance"
                        value={formData.transport_assistance}
                        onChange={handleFormChange}
                    />
                    </div>

                    <div className="col-md-4 mb-3">
                    <label>Aux. alimentación</label>
                    <input
                        className="form-control"
                        name="food_assistance"
                        value={formData.food_assistance}
                        onChange={handleFormChange}
                    />
                    </div>
                </div>
                </div>

                <div className="modal-footer">
                <button
                    className="btn btn-secondary"
                    onClick={() => setShowCreateModal(false)}
                >
                    Cancelar
                </button>
                <button
                    className="btn btn-outline-pink"
                    onClick={handleCreateOtrosi}
                    disabled={creating}
                >
                    {creating ? "Guardando..." : "Crear Otro sí"}
                </button>
                </div>
            </div>
            </div>
        </div>
        )}

    </div>
  );
};

export default Otrosi;
